import { createProgressActions, createActionCreators } from '../utils';

const fetchPlace = createActionCreators(createProgressActions('FETCH_PLACE'));
const fetchPlaces = createActionCreators(createProgressActions('FETCH_PLACES'));
const postReviews = createActionCreators(createProgressActions('POST_REVIEWS'));

export { fetchPlaces, fetchPlace, postReviews };



// WEBPACK FOOTER //
// ./src/app/models/Places/actions.ts